import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

import { useLogout } from '@/features/account';

import { accountNavigation } from './navigation';

interface AccountMenuProps {
  anchor: HTMLElement | null;
  id: string;
  onClose: () => void;
  /** From the header the menu drops down; from the sidebar footer it must rise. */
  placement: 'header' | 'sidebar-footer';
}

export const AccountMenu = ({ anchor, id, onClose, placement }: AccountMenuProps) => {
  const logout = useLogout();
  const { logout: logoutItem } = accountNavigation;
  const opensDownward = placement === 'header';

  return (
    <Menu
      id={id}
      anchorEl={anchor}
      open={anchor !== null}
      onClose={onClose}
      anchorOrigin={{ vertical: opensDownward ? 'bottom' : 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: opensDownward ? 'top' : 'bottom', horizontal: 'right' }}
      slotProps={{ list: { className: 'min-w-56' } }}
    >
      <MenuItem
        onClick={() => {
          onClose();
          logout();
        }}
      >
        <ListItemIcon className="text-content-muted">
          <logoutItem.icon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={logoutItem.label} />
      </MenuItem>
    </Menu>
  );
};
